export default {
  contract: {
    provider: {
      reference: 'Ref. contrato'
    },
    reference: 'Referencia de contrato'
  },
  customInvoice: {
    inscription: 'Inscripción Registro Mercantil'
  },
  contact: {
    reference: 'Añadir referencia de contrato',
    customization: 'Personalización de la factura',
    aditional: 'Información adicional reclamada por el pagador'
  },
  invoiceData: {
    requiredFields: '(*) Campos obligatorios',
    general: 'Datos generales',
    modify: 'Modificar datos',
    modifyContactData: 'Modificar datos de contacto',
    search: 'Buscar en Agenda',
    manualAdd: 'Añadir manualmente',
    equalToClient: 'Datos del comprador iguales a cliente',
    updateProviderData: 'Actualizar datos',
    updatedProviderData: 'Datos del proveedor actualizados correctamente',
    updateFTData: 'Actualizar datos Ficha Terceros'
  }
}
